import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { firstValueFrom } from 'rxjs';
import { ValidationReport, ValidationRequest, ValidationApiResponse } from '../../interface/ledger/ledger-system';

@Injectable({
  providedIn: 'root'
})
export class LedgerValidationService {
  constructor(private http: HttpService) { }

  // Pre-migration validation
  async validateBeforeMigration(request?: ValidationRequest): Promise<ValidationApiResponse> {
    const body = request || {};
    return firstValueFrom(this.http.get('/ledgervalidation/pre-migration'));
  }

  // Post-migration validation
  async validateAfterMigration(request?: ValidationRequest): Promise<ValidationApiResponse> {
    const body = request || {};
    return firstValueFrom(this.http.post('/ledgervalidation/post-migration', body));
  }

  // Business rules validation
  async validateBusinessRules(): Promise<ValidationApiResponse> {
    return firstValueFrom(this.http.get('/ledgervalidation/business-rules'));
  }

  // Balance calculations validation
  async validateBalanceCalculations(): Promise<ValidationApiResponse> {
    return firstValueFrom(this.http.get('/ledgervalidation/balance-calculations'));
  }
}